export enum PARAM_ANNOTATION_STRATEGY {
  REQUIRED = 'REQUIRED',
  OPTIONAL = 'OPTIONAL',
}
